import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const communicationOfficersKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'communicationOfficers'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'communicationOfficers', itemId] as const,
      }),
  });

export { communicationOfficersKeys };
